import React from "react";
import ReactModal from "react-modal";
import "./KnowledgeBaseModal.scss";

interface KnowledgeBaseModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const KnowledgeBaseModal: React.FC<KnowledgeBaseModalProps> = ({
  isOpen,
  onClose,
}) => {
  const isMobile = window.innerWidth <= 768;

  const customModalStyles: any = {
    content: {
      top: isMobile ? "0" : "50%",
      left: isMobile ? "0" : "50%",
      right: "auto",
      bottom: "auto",
      transform: isMobile ? "none" : "translate(-50%, -50%)",
      width: isMobile ? "100%" : "100%",
      maxWidth: isMobile ? "100%" : "650px",
      height: "auto",
      maxHeight: isMobile ? "600px" : "700px",
      overflowY: "auto",
      padding: "20px",
      borderRadius: isMobile ? "0" : "12px",
      display: "block",
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      contentLabel="Knowledge Base"
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
    >
      <div className="knowledge-base-modal">
        <div className="modal-header">
          <h2 className="modal-title">Knowledge Base</h2>
          <button className="close-button" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="modal-content">
          <div className="knowledge-base-content">
            <p>Knowledge Base content will be displayed here.</p>
            {/* Add your Knowledge Base content here */}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default KnowledgeBaseModal;